import axios from 'axios';
import config from '../config.json';

import {
  UPDATE_CAMSET,
  TOGGLE_SINGLE_VIEW,
  TOGGLE_FULLSCREEN_VIEW,
  CHANGE_USER_VIEW,
  UPDATE_CAMERAS_IN_VIEW,
  SHOW_UNSAVED_VIEW_MODAL,
  SAVE_VIEW,
  GET_ONLINE_STATUS_SUCCESS,
} from './types';

const API_URL = process.env.REACT_APP_BACKEND || config.backend;

// eslint-disable-next-line
export const updateCamset = (camset) => {
  return {
    type: UPDATE_CAMSET,
    payload: camset
  }
};

export const toggleSingleView = (camera) => {
  return {
    type: TOGGLE_SINGLE_VIEW,
    payload: camera
  }
};

export const toggleFullscreenView = () => {
  return {
    type: TOGGLE_FULLSCREEN_VIEW
  }
};

export const changeUserView = (viewId, userViews, token, deviceIdList, userId) => {
  // also update default view as {id: userID, viewId: view.id}
  return async ( dispatch ) => {
    let id = viewId;
    let selected = {};
    // if payload === 'new' the user has requested a new blank view to add cameras to
    if(id !== 'new'){
      selected = userViews.find(uv => parseInt(uv.id) === parseInt(id));

      // udate the users default view in local storage
      let localDefaultViews = await localStorage.getItem('defaultViews');
      let views = localDefaultViews && localDefaultViews.length > 0 ? JSON.parse(localDefaultViews) : [];
      let tViewIndex = views && views.length > 0 ? views.findIndex(v => v.id === userId) : -1;

      if(tViewIndex > -1){
        // user has a previous default view set
        views[tViewIndex].viewId = viewId;
      } else {
        // add new view for this user
        views = [...views, {id: userId, viewId: viewId}];
      }

      // set the updated default user views into browser storage
      await localStorage.setItem('defaultViews', JSON.stringify(views));
    };

    dispatch({
      type: CHANGE_USER_VIEW,
      selectedUserView: selected,
      compositeCams: selected && selected.cams && selected.cams.length > 0 ? selected.cams : [],
    })
  }
}

export const addCameraToView = (compositeCams, slotId, cameraId) => {
  return async (dispatch) => {
    let cams = Array.from(Array(16)).map((_, index) => (
      (parseInt(compositeCams[index]) > 0) ? compositeCams[index]
      : (index === parseInt(slotId)) ? parseInt(cameraId) : 0
    ))

    dispatch({
      type: UPDATE_CAMERAS_IN_VIEW,
      compositeCams: cams,
    })
  }
}

export const moveCamerasInView = (compositeCams, targetIndex, cameraId) => {
  return async (dispatch) => {
    // swap the cameras, no re-indexing
    const targetCameraId = (compositeCams[targetIndex]) ? compositeCams[targetIndex] : 0
    const camId = parseInt(cameraId)
    const camIndex = compositeCams.findIndex(cam => cam === camId);

    let cams = Array.from(Array(16)).map((_, index) => (
      index === targetIndex ? camId
      : index === camIndex ? targetCameraId
      : compositeCams[index] > 0 ? compositeCams[index] : 0
    ))

    dispatch({
      type: UPDATE_CAMERAS_IN_VIEW,
      compositeCams: cams,
    })
  }
}

export const deleteCameraInView = (compositeCams, cameraId) => {
  return async (dispatch) => {
    let cams = [...compositeCams]
    const index = cams.findIndex(cam => cam === cameraId);
    cams[index] = 0

    dispatch({
      type: UPDATE_CAMERAS_IN_VIEW,
      compositeCams: cams,
    })
  }
}

export const toggleUnsavedViewModal = (show, onClose) => {
  return {
    type: SHOW_UNSAVED_VIEW_MODAL,
    show: show,
    onClose: onClose,
  }
}

export const saveView = (viewId, viewName, customerId, compositeCams, user, userViews, deviceIdList, token, showAlertModal) => {
  return async (dispatch) => {
    const cams = compositeCams.filter(c => c !== 0)
    const reqBody = {
      id: viewId,
      name: viewName,
      customerId: customerId,
      cams: JSON.stringify(cams),
      addToUser: true,
      userId: user.bID,
    };

    await  axios({
      method: 'post',
      url: API_URL + 've/view?device=' + deviceIdList[0],
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + token
      },
      withCredentials: true,
      data: reqBody

    }).then((response) => {
      showAlertModal(['SUCCESS', 'View successfully saved.'])

      let view = {
        id: viewId ? viewId : response.data.data[0],
        label: viewName,
        customerId: customerId,
        cams: cams,
      }

      let newUserViews = [...userViews]
      if (!viewId) {
        newUserViews.push(view)
      } else {
        newUserViews = newUserViews.map(v => v.id === view.id ? view : v)
      }

      let userData = {...user}
      if (!viewId) {
        userData.sViews = JSON.stringify(newUserViews.map(c => c.id))
      }

      dispatch({
        type: SAVE_VIEW,
        compositeCams: cams,
        selectedUserView: view,
        userViews: newUserViews,
        user: userData,
        edit: viewId ? true : false,
      })

    }).catch( error => {
      showAlertModal(['ERROR', 'Unable to save View details.'])
    })
  }
}

export const getOnlineStatusUpdate = (deviceIdList, token, devices, cameras) => {
  return async ( dispatch ) => {
      await  axios({
        method: 'get',
        url: API_URL + `ve/onlinestatus?device=${deviceIdList[0]}&ids=${deviceIdList.join(':')}`,
        headers: {
          'Authorization': 'Bearer ' + token
        }

      }).then((response) => {
        let result = response.data
        let deviceArr = devices
        let cameraArr = cameras

        for (let i = 0; i < result.length; i++) {
          let device = result[i]
          let dIndex = deviceArr.findIndex(d => d.sDeviceID === device.sDeviceID)
          if (dIndex === -1) continue

          deviceArr[dIndex].fOnline = device.fOnline
          deviceArr[dIndex].sBackendID = device.sBackendID
          
          let cams = device.cams
          for (let ix = 0; ix < cams.length; ix++) {
            let camera = cams[ix]
            let cIndex = cameraArr.findIndex(c => c.bID === camera.bID)
            if (cIndex === -1) continue

            cameraArr[cIndex].fEnabled = camera.fEnabled
            cameraArr[cIndex].fOnline = device.fOnline === 0 ? 0 : camera.fOnline
          }
        }

        dispatch({
          type: GET_ONLINE_STATUS_SUCCESS,
          devices: deviceArr,
          cameras: cameraArr
        });

      }).catch( error => {
          console.log(error);
          console.log('CHECK DEVICE STATUS: FAILED')
      });
    };
};